// Specs de instancias EC2 (vCPU / RAM) por instanceType.
// Fuente única compartida para mostrar la "máquina" en los detalles de
// marketplace y app-deploy de forma homologada.

export interface Ec2Spec {
  vcpu: number;
  memoryMB: number;
}

export const EC2_SPECS: Record<string, Ec2Spec> = {
  't3.nano': { vcpu: 2, memoryMB: 512 },
  't3.micro': { vcpu: 2, memoryMB: 1024 },
  't3.small': { vcpu: 2, memoryMB: 2048 },
  't3.medium': { vcpu: 2, memoryMB: 4096 },
  't3.large': { vcpu: 2, memoryMB: 8192 },
  't3.xlarge': { vcpu: 4, memoryMB: 16384 },
  't3.2xlarge': { vcpu: 8, memoryMB: 32768 },
  // t3a (AMD) — mismas specs que t3
  't3a.nano': { vcpu: 2, memoryMB: 512 },
  't3a.micro': { vcpu: 2, memoryMB: 1024 },
  't3a.small': { vcpu: 2, memoryMB: 2048 },
  't3a.medium': { vcpu: 2, memoryMB: 4096 },
  't3a.large': { vcpu: 2, memoryMB: 8192 },
  't3a.xlarge': { vcpu: 4, memoryMB: 16384 },
  't3a.2xlarge': { vcpu: 8, memoryMB: 32768 },
};

export function getEc2Specs(instanceType?: string | null): Ec2Spec | null {
  if (!instanceType) return null;
  return EC2_SPECS[instanceType] ?? null;
}

export function formatMemory(mb?: number | null): string {
  if (!mb || mb <= 0) return '-';
  if (mb >= 1024) {
    const gb = mb / 1024;
    return `${Number.isInteger(gb) ? gb : gb.toFixed(1)} GB`;
  }
  return `${mb} MB`;
}
